import BaseApiRequest from "./BaseApiRequest";
import { GLOBAL_VAULT_GET_URL } from "../ApiUrls";
import { METHOD } from "../Constants";
import { getCurrentUserParameters } from "../../Utils/CommonUtilities";
import { formURL } from "../../Utils/CommonUtilities";

export default class GetApplicantVault extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = {};

  url = GLOBAL_VAULT_GET_URL;

  constructor(reqData) {
    super();
    const { vaultKey } = reqData;

    const paramList = [vaultKey];
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
